import { useAppLayoutContext } from '../AppLayout/hooks';

export const useIsPageLayoutVNext = () => !!useAppLayoutContext();
